<template>
  <v-card outlined>
    <!-- diplay option to toogle public profile view for creator -->
    <v-btn
      v-if="onMyProfile"
      @click="$emit('toggleOptionToSeeMyPublicProfile')"
      v-text="
        $t(
          informationsAreEditable
            ? 'account.seePublicProfile'
            : 'account.seePrivateProfile'
        )
      "
      color="primary"
      class="my-4 mx-auto d-block"
      depressed
    ></v-btn>
    <v-divider></v-divider>
    <!-- Profile Header : Avatar - Username and number of share -->
    <div class="d-flex flex-row justify-start flex-wrap pa-4">
      <!-- Avatar Images -->
      <div class="relative mr-4">
        <v-avatar size="96" class="py-2">
          <img
            v-if="creator.profilePicture"
            :src="creator.profilePicture.small"
            alt="Profile Picture"
            contain
            style="object-fit:cover"
          />
          <img
            v-else
            :src="require('@/assets/defaultProfilePicture.svg')"
            alt="Profile Picture"
            contain
          />
        </v-avatar>
        <v-btn
          v-if="informationsAreEditable"
          @click="editPictureProfile()"
          icon
          height="96"
          width="96"
          absolute
          style="top:0; left:0"
          class="picture-button"
          ><v-icon large color="white">add_a_photo</v-icon>
        </v-btn>
      </div>
      <!-- Creator Information -->
      <div>
        <!-- Username and number of gemmes explored and posts shared -->
        <div>
          <!-- Username -->
          <div class="text-truncate">
            <span
              class=" text-capitalize text-h5 font-weight-bold primary--text text-truncate"
              v-text="creator.user.username"
            >
            </span>
          </div>
          <!-- Posts and destinations information -->
          <div>
            <!-- Posts shared -->
            <span
              v-text="`${creator.postsCount} `"
              class="primary--text font-weight-bold"
            >
            </span>
            <span
              v-text="
                creator.postsCount > 1
                  ? $t('app.plural_EXPERIENCE')
                  : $t('app.singular_EXPERIENCE')
              "
              class="text--secondary"
            ></span>
            <span class="text--secondary">, </span>
            <!-- Gemmes explored -->
            <span
              v-text="`${creator.destinationsCount} `"
              class="primary--text font-weight-bold"
            ></span>
            <span
              v-text="
                creator.destinationsCount > 1
                  ? $t('app.plural_GEM_EXPLORED')
                  : $t('app.singular_GEM_EXPLORED')
              "
              class="text--secondary"
            ></span>
          </div>
        </div>
        <!-- SocialMedia -->
        <div
          v-if="
            this.creator.instagramUrl !== '' ||
              this.creator.pinterestUrl !== '' ||
              this.creator.twitterUrl !== '' ||
              this.creator.facebookUrl !== ''
          "
          style="left:-6px; position: relative"
          class="mt-2"
        >
          <div class="d-flex align-center justify-start">
            <v-tooltip top v-if="this.creator.instagramUrl">
              <template v-slot:activator="{ on }">
                <v-btn icon :href="creator.instagramUrl" target="_blank">
                  <v-icon color="primary" v-on="on">fab fa-instagram</v-icon>
                </v-btn>
              </template>
              <span>{{ this.creator.instagramUrl }}</span>
            </v-tooltip>
            <v-tooltip top v-if="this.creator.twitterUrl">
              <template v-slot:activator="{ on }">
                <v-btn icon :href="creator.twitterUrl" target="_blank">
                  <v-icon color="primary" v-on="on">fab fa-twitter</v-icon>
                </v-btn>
              </template>
              <span>{{ this.creator.twitterUrl }}</span>
            </v-tooltip>
            <v-tooltip top v-if="this.creator.facebookUrl">
              <template v-slot:activator="{ on }">
                <v-btn icon :href="creator.facebookUrl" target="_blank">
                  <v-icon v-on="on" color="primary">fab fa-facebook</v-icon>
                </v-btn>
              </template>
              <span>{{ this.creator.facebookUrl }}</span>
            </v-tooltip>
            <v-tooltip top v-if="this.creator.pinterestUrl">
              <template v-slot:activator="{ on }">
                <v-btn icon :href="creator.pinterestUrl" target="_blank">
                  <v-icon v-on="on" color="primary">fab fa-pinterest</v-icon>
                </v-btn>
              </template>
              <span>{{ this.creator.pinterestUrl }}</span>
            </v-tooltip>
          </div>
        </div>
        <!-- Edit ProfileInformationButton -->
        <v-btn
          depressed
          outlined
          v-if="informationsAreEditable"
          @click="triggerEdit()"
          class="text-capitalize mt-2"
          color="secondary"
        >
          Éditer
        </v-btn>
      </div>
    </div>
    <!-- Avatar description -->
    <div
      v-if="creator.description.length"
      class="pa-4 grey--top--border text-justify"
    >
      <span class="font-italic" v-text="creator.description"></span>
      <div
        v-text="`“${creator.user.username}”`"
        class="mt-4 text-capitalize font-italic primary--text text-right font-weight-bold"
      ></div>
    </div>
    <!-- Websites and YouTube channels -->
    <div class="grey--top--border text-center">
      <div
        class="text-h6 font-weight-bold primary--text text-center pt-4"
        v-text="
          creator.websites.length + creator.youtubeChannels.length > 1
            ? `${$t('profile.plural_CHEST_OF')} ${$t('app.plural_GEM')}`
            : `${$t('profile.singular_CHEST_OF')} ${$t('app.plural_GEM')}`
        "
      ></div>
      <div
        v-if="informationsAreEditable"
        class="d-flex justify-center flex-wrap"
      >
        <v-btn
          small
          text
          color="primary"
          class="text-lowercase font-weight-medium mb-2"
          @click.stop="displayHowToFillGemsChest = !displayHowToFillGemsChest"
        >
          ajouter un coffre ?
        </v-btn>
        <v-slide-y-transition>
          <v-alert
            v-show="displayHowToFillGemsChest"
            dense
            text
            color="primary"
            width="80%"
          >
            Tu peux nous transmettre ta demande par
            <span class="font-weight-bold">email via contact@gemmici.com</span>
            ou par
            <span class="font-weight-bold">message privé sur Facebook</span>.
          </v-alert>
        </v-slide-y-transition>
      </div>

      <v-list class="pb-0 text-start">
        <!-- WEBSITES -->
        <v-list-item
          v-for="website in creator.websites"
          :key="website.name"
          :href="website.url"
          target="blank"
        >
          <v-list-item-action class="my-0">
            <v-btn small icon color="primary">
              <v-icon>
                fas fa-link
              </v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              v-text="website.name"
              class="underline--on--hover font-weight-bold"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- YOUTUBE CHANNELS -->
        <v-list-item
          v-for="youtubeChannel in creator.youtubeChannels"
          :key="youtubeChannel.id"
          :href="youtubeChannel.url"
          target="blank"
        >
          <v-list-item-action class="my-0">
            <v-btn small icon color="primary">
              <v-icon>
                fab fa-youtube
              </v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              v-text="youtubeChannel.title"
              class="underline--on--hover font-weight-bold"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
    <!-- Mes Gems -->
    <div
      v-if="this.creator.departments.length || this.creator.themes.length"
      class="grey--bottom--top gemmes-section"
    >
      <div class="pa-4 text-h6 font-weight-bold primary--text text-center">
        Facettes
      </div>
      <v-list class="pa-0" style="background-color: transparent">
        <div v-for="theme in this.creator.themes" :key="theme.id">
          <router-link
            :to="{
              name: $route.name,
              query: {
                [theme.category]: [theme.nameEn]
              }
            }"
          >
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary">fas fa-hashtag</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                  v-text="theme.nameFr"
                  class="underline--on--hover text-capitalize font-weight-bold"
                >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </div>

        <div
          v-for="department in this.departmentsWithBbox"
          :key="department.shortName"
        >
          <router-link
            :to="{
              name: $route.name,
              query: {
                placeType: 'department',
                longName: department.longName,
                shortName: department.shortName,
                xMin: department.bbox[0],
                xMax: department.bbox[2],
                yMin: department.bbox[1],
                yMax: department.bbox[3]
              }
            }"
          >
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary">fas fa-map-marker-alt</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                  v-text="department.shortName"
                  class="underline--on--hover font-weight-bold"
                >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </div>
      </v-list>
    </div>
  </v-card>
</template>
<script>
import ProfileService from "../services/ProfileService";
export default {
  name: "TheAccountDisplay",

  props: {
    profileDisplayProp: Object,
    creator: Object,
    informationsAreEditable: { type: Boolean, default: () => false },
    onMyProfile: { type: Boolean, default: () => false }
  },
  data() {
    return {
      departmentsWithBbox: [],
      displayHowToFillGemsChest: false
    };
  },
  methods: {
    triggerEdit() {
      this.$emit("editing");
    },
    editPictureProfile() {
      this.$emit("editPictureProfile");
    },
    searchThisTheme(theme) {
      this.$router.push({ name: "home", query: { themes: [theme] } });
    },
    updateDepartmentsWithBbox() {
      ProfileService.updateDepartmentsWithBbox(this.creator.departments).then(
        response => (this.departmentsWithBbox = response)
      );
    }
  },
  created() {
    this.updateDepartmentsWithBbox();
  },
  watch: {
    creator() {
      this.updateDepartmentsWithBbox();
    }
  }
};
</script>

<style scoped>
.gemmes-section {
  background-image: url("../../assets/background/glamorous.svg");
  background-repeat: repeat;
}
.picture-button {
  opacity: 0;
  transition: 0.3s;
}
.picture-button:hover {
  opacity: 1;
}
</style>
